import "./application.css"
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import ahoy from "ahoy.js"
ahoy.configure({ visitsUrl: "/api/t/visits", eventsUrl: "/api/t/events" })
import "@37signals/lexxy"
import "@rails/actiontext"
import "@videojs/html/video/player"
import "@videojs/html/video/skin"
import "@videojs/html/video/skin.css"

// Import static assets so they're included in the Vite manifest for vite_asset_path
import "../images/authentication-background.jpg"
import "../videos/lumenfall-hero.webm"
import "../videos/lumenfall-hero.mp4"
import "../images/lumenfall-icon.png"

// Provider logos for homepage
import "../images/providers/openai.svg"
import "../images/providers/google.svg"
import "../images/providers/recraft.svg"
import "../images/providers/fal.svg"
import "../images/providers/replicate.svg"
import "../images/providers/runware.svg"

// Add lexxy-content class to Lexxy editors so all content styles apply
function setupLexxyEditors() {
  document.querySelectorAll('lexxy-editor .lexxy-editor__content').forEach(el => {
    el.classList.add('lexxy-content')
  })
}
document.addEventListener('turbo:load', setupLexxyEditors)
document.addEventListener('DOMContentLoaded', setupLexxyEditors)

// Close <details class="dropdown"> when clicking outside or on a different dropdown
document.addEventListener("click", (event) => {
  const clickedInside = (event.target as Element)?.closest?.("details.dropdown")
  document.querySelectorAll<HTMLDetailsElement>("details.dropdown[open]").forEach((d) => {
    if (d !== clickedInside) d.open = false
  })
})

// Watch for dynamically added editors
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element && node.matches?.('lexxy-editor')) {
        node.querySelector('.lexxy-editor__content')?.classList.add('lexxy-content')
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });

// Custom turbo-stream action: push a URL through Turbo's navigator so history
// and back/forward continue to work through Turbo. Emit from the server as:
//   <turbo-stream action="advance" url="..."></turbo-stream>
(Turbo.StreamActions as Record<string, (this: Element) => void>).advance = function () {
  const url = this.getAttribute("url");
  if (!url) return;
  Turbo.navigator.history.push(new URL(url, window.location.origin));
};

import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()

// Load all controllers EXCEPT heavy ones that have their own entry points:
// - playground_controller (highlight.js ~50KB)
// - stripe_setup_controller (@stripe/stripe-js)
const controllers = import.meta.glob([
  "../controllers/**/*_controller.{js,ts,tsx}",
  "!../controllers/playground_controller.ts",
  "!../controllers/stripe_setup_controller.ts",
  "!../controllers/stripe_payment_confirm_controller.ts",
], { eager: true })
registerControllers(application, controllers)